import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import Quiz, { QuizAnswer } from "../../../models/quiz.model";

@Component({
  selector: "ngx-view-quiz-answer",
  styleUrls: ["./view-quiz-answer.component.scss"],
  templateUrl: "./view-quiz-answer.component.html",
})
export class ViewQuizAnswerComponent implements OnInit {
  @Input() submitted: boolean;
  @Input() ans: QuizAnswer;
  @Output() onSelectedAns: EventEmitter<any> = new EventEmitter();

  loading = false;

  status() {
    if (!this.submitted) {
      if (this.ans.selected) {
        return "success";
      } else {
        return "info";
      }
    } else {
      if (this.ans.selected && !this.ans.isCorrect) {
        return "danger";
      } else if (this.ans.isCorrect) {
        return "success";
      } else {
        return "info";
      }
    }
  }

  constructor() {}

  ngOnInit(): void {
    if (!this.ans.content) {
      this.ans.content = "";
    }
  }

  selected() {
    if (this.submitted == false) {
      this.ans.selected = !this.ans.selected;
      this.onSelectedAns.emit(this.ans);
    }
  }
}
